/**
 * Professional Flag Icons using official SVGs
 * Clean flag representations for e-commerce
 */

import React from 'react';

// Flag URLs from Wikipedia (official designs)
const FLAG_URLS = {
  US: 'https://upload.wikimedia.org/wikipedia/commons/a/a4/Flag_of_the_United_States.svg',
  GB: 'https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg',
};

/**
 * FlagIcon Component
 * @param {string} countryCode - ISO country code (US, GB)
 * @param {string} className - Tailwind classes for sizing
 */
const FlagIcon = ({ countryCode, className = "w-5 h-4" }) => {
  const code = countryCode?.toUpperCase();
  const flagUrl = FLAG_URLS[code];
  
  if (!flagUrl) {
    // Fallback globe icon for unknown countries
    return (
      <svg className={className} viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="14" rx="1.5" fill="#E5E7EB"/>
        <circle cx="10" cy="7" r="5" stroke="#6B7280" strokeWidth="1.2" fill="none"/>
        <ellipse cx="10" cy="7" rx="2" ry="5" stroke="#6B7280" strokeWidth="1"/>
        <line x1="5" y1="7" x2="15" y2="7" stroke="#6B7280" strokeWidth="1"/>
      </svg>
    );
  }
  
  return (
    <img 
      src={flagUrl}
      alt={`${code} flag`}
      className={`${className} object-cover rounded-sm`}
      loading="lazy"
    />
  );
};

export { FlagIcon, FLAG_URLS };
export default FlagIcon;
